import { defineMessages } from 'react-intl';

const messages = defineMessages({
  newPassword: {
    description: 'changePassword.newPassword',
    defaultMessage: 'New Password',
    id: '/NUYSG',
  },
  confirmPassword: {
    description: 'changePassword.confirmPassword',
    defaultMessage: 'Confirm Password',
    id: '0kKmCo',
  },
  errorPleaseEnterNewPassword: {
    description: 'changePassword.errorPleaseEnterNewPassword',
    defaultMessage: 'Please enter a new password.',
    id: 'L/TUk5',
  },
  errorPasswordDoesNotMatch: {
    description: 'changePassword.errorPasswordDoesNotMatch',
    defaultMessage: 'Your confirm password does not match.',
    id: 'QxwlkQ',
  },
  errorUnableToCommunicateWithServer: {
    description: 'changePassword.errorUnableToCommunicateWithServer',
    defaultMessage: 'Unable to communicate with the server.',
    id: 'pNkUhY',
  },
  errorWhileChangingPassword: {
    description: 'changePassword.errorWhileChangingPassword',
    defaultMessage: 'Error while changing password.',
    id: 'hx8oJu',
  },
  successPasswordHasBeenUpdated: {
    description: 'changePassword.successPasswordHasBeenUpdated',
    defaultMessage: 'Your password has been updated. Please click on the login link below.',
    id: 'TBqmtz',
  },
  privacyLink: {
    description: 'changePassword.privacyLink',
    defaultMessage: 'Privacy Policy',
    id: 'UB6eWR',
  },
  termsLink: {
    description: 'changePassword.termsLink',
    defaultMessage: 'Terms of Service',
    id: '8oiJiw',
  },
  createAnAccount: {
    description: 'changePassword.createAnAccount',
    defaultMessage: 'Create an Account',
    id: 'xF8l3U',
  },
  login: {
    description: 'changePassword.login',
    defaultMessage: 'Login',
    id: 'g4wQIO',
  },
  setupPassword: {
    description: 'changePassword.setupPassword',
    defaultMessage: 'Setup Password',
    id: '3FGWXp',
  },
  changePassword: {
    description: 'changePassword.changePassword',
    defaultMessage: 'Change Password',
    id: 'FZX5R5',
  },
  setupInstructions: {
    description: 'changePassword.setupInstructions',
    defaultMessage: 'Please setup your password.',
    id: 'mRUPK1',
  },
  setupTitle: {
    description: 'changePassword.setupTitle',
    defaultMessage: 'Almost Done!',
    id: 'x3+xBg',
  },
  resetInstructions: {
    description: 'changePassword.resetInstructions',
    defaultMessage: 'Please enter a new password.',
    id: 'BqtJnV',
  },
  resetTitle: {
    description: 'changePassword.resetTitle',
    defaultMessage: 'Update your password',
    id: 'B6/+ht',
  },
});

export default messages;
